jQuery(document).ready(function ($) {
    "use strict";

    function makeTwoDigits( number ) {
        if ( number < 10) {
            return '0' + number;
        }

        return number;
    }

    var countdown_element = '[data-countdown]';

    $.each( $( countdown_element ), function ( index, value ) {

        if ( $( value ) && $( value ).data( 'countdown' ) ) {

            var sale_ends = moment( $( value ).data( 'countdown' ), 'YYYY-MM-DD hh:mm:ss' );

            if ( sale_ends ) {

                if ( $( value ).closest( $( '[data-countdown-display]' ) ) ) {

                    var timespan = countdown( sale_ends, function(ts) {
                        $( value ).find( $( '[data-countdown-days]' ) ).html( makeTwoDigits( ts.days ) );
                        $( value ).find( $( '[data-countdown-hours]' ) ).html( makeTwoDigits( ts.hours ) );
                        $( value ).find( $( '[data-countdown-minutes]' ) ).html( makeTwoDigits( ts.minutes ) );
                        $( value ).find( $( '[data-countdown-seconds]' ) ).html( makeTwoDigits( ts.seconds ) );
                    }, countdown.DAYS|countdown.HOURS|countdown.MINUTES|countdown.SECONDS );
                }
            }
        }
    });
});
